export default __webpack_public_path__ + "static/media/table-bench-covered.b103e91e.png";